module.exports = __webpack_public_path__ + "static/fieldworkImage-ba01ef34a3535f945a3eda91c56d09dc.jpg";